<style>
/* .ck .ck-content {
    
} */

.ck-editor__editable {
    min-height: 400px;
    /* list-style-type: inherit; */
    /* padding: 20px !important; */
}

/* .ck.ck-content ul,
.ck.ck-content ul li{
  list-style-type: inherit;
} */

.ck.ck-content ul {
    /* Default user agent stylesheet, you can change it to your needs. */
    padding-left: 30px;
}

.ck.ck-content ol {
    /* Default user agent stylesheet, you can change it to your needs. */
    padding-left: 30px;
}

/* .ck.ck-content ul,
.ck.ck-content ul li {
  list-style-type: inherit;
} */
</style>

<template>
    <Card style="width: 100%" shadowx>
        <!-- <p slot="title"> -->
        <div slot="title" style="height: 20px;">
            <Breadcrumb style="padding-top: 3px;">
                <BreadcrumbItem v-for="(item, index) in breadcrumb" v-bind:key="index">{{ item }}</BreadcrumbItem>
            </Breadcrumb>
        </div>
        <!-- </p> -->

        <!-- <Row style="margin-bottom: 8px;" :gutter="8"> -->
        <!-- <i-col span="12">
			<Card>
				<div id="imghs-host" style="height: 200px;">
					<div id="imghs" style="height: 300px; width: 533px; background-colorXXX: blue;">
						<img src="layout-ss.png" style="height: 100%; width: 100%; object-fit: contain;">
						<div style="position: absolute; left: 0px; top: 0px; right: 0px; bottom: 0px; xbackground-color: red;">
							<div v-for="item in $store.state.playlist" :key="item.path" @click="$store.state.path = item.path" :style="{position: 'absolute',
								left: item.zone[0] + 'px', top: item.zone[1] + 'px', width: item.zone[2] + 'px', height: item.zone[3] + 'px', backgroundColor: $store.state.path == item.path ? 'rgba(255,0,0,0.6)' : 'rgba(128,128,255,0.6)'}">
							</div>
						</div>
					</div>
				</div>
			</Card>
        </i-col>-->

        <!-- <i-col span="12" style="height: 234px; xbackground-color: red;"> -->
        <Upload :disabled="$store.state.path === '*'" :style="{ width: '100%' }" :styleX="{
            position: 'fixed', top: '64px', left: '244px', right: '24px',
            zIndex: 1000
        }" ref="upload" multiple type="drag" action="/file.upload" name="media" :on-success="uploadSuccess"
            :data="{ path: $store.state.path + '/' + $store.state.lang }"
            :format="['jpg', 'jpeg', 'png', 'mp4', 'pdf', 'fbx', 'glb', 'dae']">
            <div style="padding: 20px 0">
                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                <p>Click or drag files here to upload</p>
            </div>
        </Upload>
        <!-- </i-col> -->
        <!-- </Row> -->

        <!-- <div style="padding: 5px; text-align: center;">
            <RadioGroup v-model="$store.state.lang" type="button" @on-change="selectLang">
                <Radio label>
                    <Icon type="ios-flag" />
                    <span>All</span>
                </Radio>
                <Radio label="id">
                    <span>Bahasa</span>
                </Radio>
                <Radio label="en">
                    <span>English</span>
                </Radio>
            </RadioGroup>
        </div> -->



        <!-- <Layout :style="{overflowY: 'scroll', marginTop: '60px'}"> -->
        <div style="margin: 8px 0;">
            <Button type="error" size="small" icon="ios-trash"
                :disabled="selectedItems.length === 0"
                @click="removeSelected">
                Delete Selected{{ selectedItems.length ? ` (${selectedItems.length})` : '' }}
            </Button>
        </div>
        <Table @on-selection-change="handleSelectionChange" :styleX="{ marginTop: '100px' }" heightx="300" border :columns="columns" :data="items"></Table>
        <!-- </Layout> -->

        <Modal v-model="showBatchDeleteConfirm" title="Delete Confirmation" width="360">
            <p style="text-align:center">
                <Icon type="ios-information-circle" style="color:#f60;font-size:48px;"></Icon>
            </p>
            <p style="text-align:center;font-size:16px;margin-top:12px;">
                Delete {{ selectedItems.length }} file(s)?
            </p>
            <p style="text-align:center;font-size:12px;color:#999;margin-top:8px;">
                This action cannot be undone.
            </p>
            <div slot="footer" style="text-align:center">
                <Button type="default" size="large" @click="showBatchDeleteConfirm = false">Cancel</Button>
                <Button type="error" size="large" @click="confirmRemoveSelected">Delete</Button>
            </div>
        </Modal>

        <Modal v-model="showPreview" title="Preview">

            <!-- <img style="width: 100%;" v-bind:src="selectedItemPath" /> -->

            <img v-if="['jpeg', 'jpg', 'png', 'bmp', 'gif'].indexOf(selectedItemPath.split('.').pop().toLowerCase()) >= 0"
                style="width: 100%;" v-bind:src="selectedItemPath" />
            <video v-else-if="['mp4', 'avi', 'mov'].indexOf(selectedItemPath.split('.').pop().toLowerCase()) >= 0"
                autoplay controls style="width: 100%;" v-bind:src="selectedItemPath" />
            <iframe v-else style="width: 100%; height: 300px; border: none;" v-bind:src="selectedItemPath"></iframe>

            <div slot="footer" stylex="text-align: center">
                <Button type="primary" style="padding-left: 20px; padding-right: 20px;" longx
                    v-on:click="showPreview = false">OK</Button>
            </div>
        </Modal>

        <Modal v-model="showText"
            :title="this.breadcrumb[this.breadcrumb.length - 1] == 'Sisfo Berita' ? 'Filter' : `Text Editor - ${$store.state.lang || 'All'}`"
            width="50%" @on-ok="saveText">
            <!-- <Input v-model="selectedItem.text" type="textarea" rows=10 placeholder="Media Description" /> -->

            <template v-if="this.breadcrumb[this.breadcrumb.length - 1] == 'Sisfo Berita'">
                <Input v-model="tempText" type="textarea" :rows=5 placeholder="Query Filter" />
            </template>
            <template v-else>
                <ckeditor :editor="editor" @ready="onEditorReady" :config="editorConfig"></ckeditor>
            </template>


            <!-- <div slot="footer" stylex="text-align: center">
        <Button
          type="primary"
          style="padding-left: 20px; padding-right: 20px;"
          longx
          v-on:click="saveText"
        >OK</Button>
            </div>-->
        </Modal>
    </Card>
</template>

<script>
// const fit = require('../vendor/fit');
// import { fit } from '../vendor/fit';

// console.log(fit);
// console.log('sdfds')

import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
    components: {
        ckeditor: CKEditor.component
    },
    methods: {
        selectLang() {
            // console.log('Select lang', this.$store.state.path, this.$store.state.lang);
            // this.$store.state.path = this.$store.state.path +

            this.changePath(
                this.$store.state.path + "/" + this.$store.state.lang
            );
        },

        show(index) {
            this.selectedItem = this.items[index];
            this.selectedItemPath = this.resolveMediaUrl(this.selectedItem.path);
            this.showPreview = true;
            //   this.$Modal.info({
            //     title: 'Preview',
            //     content: `<img style="width: 100%;" src="${this.items[index].path}">`
            //   })
        },

        resolveMediaUrl(path) {
            if (!path) {
                return "";
            }

            if (/^https?:\/\//i.test(path)) {
                return path;
            }

            const normalizedPath = path[0] === "/" ? path : `/${path}`;

            // In dev, opening `/Media/...` in a new tab can be handled by webpack SPA fallback.
            // Force backend origin to always serve the raw media file.
            if (process.env.NODE_ENV === "development") {
                return `http://${window.location.hostname}:3000${normalizedPath}`;
            }

            return normalizedPath;
        },

        text(index) {
            // console.log('text', index, this.selectedItem.text);

            this.selectedItem = this.items[index];

            //   console.log(this.selectedItem);

            if (this.selectedItem.text) {
                this.tempText = this.selectedItem.text || "";
                this.ckeditor.setData(this.selectedItem.text || "");
                this.showText = true;
            } else {
                fetch(this.selectedItem.path + ".txt")
                    .then(resp => {
                        // console.log(resp);

                        return resp.ok ? resp.text() : "";
                    }) // Transform the data into json
                    .then(data => {
                        // console.log("anu", data);
                        this.tempText = data;
                        this.selectedItem.text = data;
                        this.ckeditor.setData(data || "");
                        this.showText = true;
                        //   if (data.success) {
                        //     this.items.splice(index, 1);
                        //   } else {
                        //     this.$Modal.error({
                        //       title: "Remove Failed",
                        //       content: `Cannot remove ${this.items[index].name}`
                        //     });
                        //   }
                    })
                    .catch(e => {
                        // console.log('ERROR', e);
                    });
            }

            //   this.ckeditor.setData(this.selectedItem.text || "");
            //   this.showText = true;

            //   this.$Modal.info({
            //     title: 'Preview',
            //     content: `<img style="width: 100%;" src="${this.items[index].path}">`
            //   })
        },

        onEditorReady(editor) {
            this.ckeditor = editor;
            // console.log( 'Editor is ready.', editor);

            // ... use the API of the "editor" object here.

            // console.log(Array.from( editor.ui.componentFactory.names() ))
            // console.log(Array.from( editor.ui.componentFactory.names() ))
        },

        saveText() {
            // console.log(this.ckeditor.getData());

            this.selectedItem.text = this.breadcrumb[this.breadcrumb.length - 1] == 'Sisfo Berita' ? this.tempText : this.ckeditor.getData();

            const formData = new FormData();
            formData.append(
                "path",
                this.$store.state.path + "/" + this.$store.state.lang
            );

            const blob = new Blob([this.selectedItem.text], {
                type: "text/xml"
            });
            formData.append(
                "media",
                blob,
                this.selectedItem.path.substring(
                    this.selectedItem.path.lastIndexOf("/") + 1
                ) + ".txt"
            );

            fetch("/file.upload", {
                method: "POST",
                body: formData
            });

            this.showText = false;

            // console.log(this.selectedItem);
        },

        remove(index) {
            fetch(`/api/file.delete?Path=${encodeURIComponent(decodeURI(this.items[index].path))}`)
                .then(resp => resp.json()) // Transform the data into json
                .then(data => {
                    // console.log(data);
                    if (data.success) {
                        // this.items.splice(index, 1);

                        // alse delete .txt file
                        fetch(
                            `/api/file.delete?Path=${encodeURIComponent(decodeURI(this.items[index].path) + '.txt')}`
                        );

                        this.items.splice(index, 1);
                    } else {
                        this.$Modal.error({
                            title: "Remove Failed",
                            content: `Cannot remove ${this.items[index].name}`
                        });
                    }
                });
        },

        handleSelectionChange(selection) {
            this.selectedItems = selection;
        },

        removeSelected() {
            if (this.selectedItems.length === 0) return;
            this.showBatchDeleteConfirm = true;
        },

        confirmRemoveSelected() {
            const items = [...this.selectedItems];
            this.selectedItems = [];
            this.showBatchDeleteConfirm = false;

            let pending = items.length;
            if (pending === 0) return;

            items.forEach(item => {
                const p = encodeURIComponent(decodeURI(item.path));
                fetch(`/api/file.delete?Path=${p}`)
                    .then(resp => resp.json())
                    .then(data => {
                        if (data.success) {
                            return fetch(
                                `/api/file.delete?Path=${encodeURIComponent(decodeURI(item.path) + '.txt')}`
                            );
                        }
                    })
                    .catch(() => {})
                    .finally(() => {
                        pending--;
                        if (pending === 0) {
                            this.changePath(
                                this.$store.state.path + "/" + this.$store.state.lang
                            );
                        }
                    });
            });
        },

        uploadSuccess() {
            // console.log('Upload Success');

            setTimeout(() => {
                this.$refs.upload.clearFiles();
                this.changePath(
                    this.$store.state.path + "/" + this.$store.state.lang
                );
            }, 1000);
        },

        changePath(path) {
            // console.log("CP " + path);

            fetch(`/api/file.get?Path=${encodeURIComponent(path)}`)
                .then(resp => resp.json()) // Transform the data into json
                .then(data => {
                    // console.log(data);
                    if (data.success) {
                        this.items = data.payload
                            .filter(item => {
                                // console.log(item)
                                return (
                                    item
                                        .split(".")
                                        .pop()
                                        .toLowerCase() != "txt"
                                );
                            })
                            .map(item => {
                                return {
                                    path: item,
                                    name: decodeURI(item)
                                        .split("/")
                                        .pop()
                                };
                            });

                        // console.log(this.items);
                    }
                });
        }
    },

    created() {
        // console.log("PATH", this.$store.state.path);

        // this.$store.state.path = 'iklan2';
        this.changePath(this.$store.state.path + "/" + this.$store.state.lang);
        // console.log("Mounted yes");

        // this.$store.watch("path", (path, old) => {
        // //   console.log(">>" + path);
        //     this.changePath(path);
        // });

        this.unwatch = this.$store.watch(
            state => state.path,
            path => {
                //   console.log(">>" + path);

                this.breadcrumb = path
                    .split("/")
                    .map(item => item.toTitleCase());
                this.changePath(path + "/" + this.$store.state.lang);
            }
        );
    },

    mounted: function () {
        this.$nextTick(function () {
            // Code that will run only after the
            // entire view has been rendered
            // console.log('FIT')
            // fit(document.getElementById('imghs'), document.getElementById('imghs-host'), {
            //     hAlign: fit.CENTER, // or fit.LEFT, fit.RIGHT
            //     vAlign: fit.CENTER,
            //     watch: true,
            //     // apply: true
            // })
        });
    },

    destroyed() {
        //   console.log(this.unwatch);
        this.unwatch();
    },

    data() {
        return {
            // playlist: [],
            //   lang: "",

            showPreview: false,
            showText: false,
            showBatchDeleteConfirm: false,
            //   selectedItem: {
            //     text: "",
            //     path: ""
            //   },
            selectedItem: {},
            selectedItemPath: "",
            editoData: "",

            breadcrumb: ['Playlist', 'Items'],

            tempText: '',

            items: [],
            selectedItems: [],
            columns: [
                {
                    type: "selection",
                    width: 60,
                    align: "center"
                },
                {
                    title: "Filename",
                    key: "name",
                    render: (h, params) => {
                        // return h('div', [
                        //     h('Icon', {
                        //         props: {
                        //             type: 'person'
                        //         }
                        //     }),
                        //     h('strong', params.row.name)
                        // ]);

                        return h(
                            "a",
                            {
                                attrs: {
                                    href: this.resolveMediaUrl(params.row.path),
                                    target: "_blank"
                                }
                            },
                            params.row.name
                        );
                    }
                },

                {
                    title: "Action",
                    key: "action",
                    width: 210,
                    align: "center",
                    render: (h, params) => {
                        return h("div", [
                            h(
                                "Button",
                                {
                                    props: {
                                        type: "primary",
                                        size: "small"
                                    },
                                    style: {
                                        marginRight: "5px"
                                    },
                                    on: {
                                        click: () => {
                                            this.show(params.index);
                                        }
                                    }
                                },
                                "View"
                            ),
                            // h(
                            //     "Button",
                            //     {
                            //         props: {
                            //             type: "success",
                            //             size: "small"
                            //         },
                            //         style: {
                            //             marginRight: "5px"
                            //         },
                            //         on: {
                            //             click: () => {
                            //                 this.text(params.index);
                            //             }
                            //         }
                            //     },

                            //     this.breadcrumb[this.breadcrumb.length-1] == 'Sisfo Berita' ? 'Filter' : 'Text'
                            // ),
                            h(
                                "Button",
                                {
                                    props: {
                                        type: "error",
                                        size: "small"
                                    },
                                    on: {
                                        click: () => {
                                            this.remove(params.index);
                                        }
                                    }
                                },
                                "Delete"
                            )
                        ]);
                    }
                }
            ],

            editor: ClassicEditor,
            editorConfig: {
                height: "400px",
                toolbar: [
                    "heading",
                    "|",
                    "bold",
                    "italic",
                    "bulletedList",
                    "numberedList",
                    "blockQuote",
                    "|",
                    "insertTable",
                    "tableColumn",
                    "tableRow",
                    "mergeTableCells",
                    "|",
                    "undo",
                    "redo"
                ]
            }
        };
    }

    /*
    0 "undo"
    1 "redo"
    2 "bold"
    3 "italic"
    4 "blockQuote"
    5 "ckfinder"
    6 "imageTextAlternative"
    7 "imageUpload"
    8 "heading"
    9 "imageStyle:full"
    10 "imageStyle:side"
    11 "link"
    12 "numberedList"
    13 "bulletedList"
    14 "mediaEmbed"
    15 "insertTable"
    16 "tableColumn"
    17 "tableRow"
    18 "mergeTableCells"
    */
    // watch: {
    //     path(newPath) {
    //         console.log('>>' + newPath);
    //     }
    // }
    //   computed: {
    //     playlistx() {
    //       return this.$store.state.playlist;
    //     }
    //   }
};

// console.log('items', Array.from(ClassicEditor.ui.componentFactory.names() ))
</script>